import React, { useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useWalletClient } from "wagmi";
import { getContract, waitForTransaction } from "wagmi/actions";
import abi from "../../helpers/abi";
import { helperConstants as constants } from "../../helpers/helperConstants";
import { normalizeEther } from "../../helpers/digits";
import { closeModal } from "../../redux/counterSlice";
import { ChainIcon } from "../Icon";
import { getTokenName } from "../../helpers/getChainName";
import { ModalContainer } from "./modalContainer";
import { ModalItemDetails } from "./modalComponents/modalItemDetails";
import useGetTokenPrice from "../../services/useGetTokenPrice";
import { LENDING_CONTRACT_ADDRESS } from "../../lib/constants";
import cancelLendOfferByOfferID from "../../services/cancelLendOfferByOfferID";
import Link from "next/link";

const MODAL_KEY = "CancelModal";
const CancelModal = () => {
  const { modal } = useSelector((state: any) => state.counter);
  const [buttonText, setButtonText] = useState("Cancel Order");
  const { item, collection, refresh, ...offer } = modal?.data;
  const wrappedToken = offer.paymentToken.toLowerCase();
  // const { switchNetwork } = useSwitchNetworkWrapper();
  // const { supportedChains } = constants?.helpers;

  const dispatch = useDispatch();

  const { data: walletClient, status } = useWalletClient();
  const setUpdated = modal?.data?.setUpdated;

  const { usdPrice: tokenPrice, currentChainId } = useGetTokenPrice(item?.chain);

  const onCancel = async () => {
    // console.log(id);

    if (status !== "success") return;

    // setButtonLoading(true);
    setButtonText("Canceling the order...");
    try {
      let inputForSignature = {
        issuer: offer?.issuer,
        nftAddresses: [item?.collectionAddress],
        // colleteralTokenIDs: [Number(offer?.lendOrders?.colleteralTokenID)],
        colleteralTokenIDs: [Number(offer?.colleteralTokenID)],
        amounts: [Number(offer?.amount)],
        paymentToken: offer?.paymentToken,
        borrowAmount: offer?.borrowAmount,
        interestRate: Number(offer?.interestRate),
        times: {
          signingTime: Number(offer?.signingTime),
          expiration: Number(offer?.expiration),
          duration: Number(offer?.duration),
        },
        orderKind: Number(offer?.orderKind),
        tokenKinds: [Number(offer?.tokenKind)],
        isGlobal: offer?.isGlobal,
      };

      let inputForOrderArg = [
        inputForSignature.issuer,
        inputForSignature.nftAddresses,
        inputForSignature.colleteralTokenIDs,
        inputForSignature.amounts,
        inputForSignature.paymentToken,
        inputForSignature.borrowAmount,
        inputForSignature.interestRate,
        [
          inputForSignature.times.signingTime,
          inputForSignature.times.expiration,
          inputForSignature.times.duration,
        ],
        inputForSignature.orderKind,
        inputForSignature.tokenKinds,
        inputForSignature.isGlobal,
      ];

      const lendingContract = getContract({
        address: LENDING_CONTRACT_ADDRESS,
        abi,
        walletClient,
      });

      // await (
      //   await lendingContract.cancelOrder(inputForOrderArg, offer?.signature)
      // ).wait();
      const tx = await lendingContract.write.cancelOrder([inputForOrderArg, offer?.signature]);

      await waitForTransaction({
        hash: tx,
      });
      // console.log(
      //   await lendingContract.verify(inputForOrderArg, offer?.signature)
      // );

      const res = await cancelLendOfferByOfferID({ id: offer?.id });
      toast.success((t) => (
        <span>
          Order cancelled! Here is your{" "}
          <Link
            href={`${
              constants?.helpers?.supportedChains?.find((c: any) => c.hexId === currentChainId)
                ?.scan_url
            }/tx/${tx}`}
          >
            <a target="_blank" rel="noopener noreferrer">
              <b>transaction.</b>
            </a>
          </Link>
        </span>
      ));
      // if (res.status === "success") {
      //   toast.success("Offer canceled");
      // } else {
      //   toast.error("Something went wrong");
      // }

      refresh && refresh();
      dispatch(closeModal());
    } catch (err) {
      toast.error(err.reason ? err.reason : "err:" + err);
    } finally {
      // setButtonLoading(false);
      // refreshOffers();
      setButtonText("Cancel Order");
    }
  };

  const isGlobal = modal?.data?.isGlobal;
  const image = item?.imageFtpPath
    ? constants.cdn.path + item?.imageFtpPath + constants.cdn.thumbnail + constants.cdn.version
    : item?.metadata?.image
    ? item?.metadata?.image
    : constants.helpers.noImage;
  const thumbnail =
    modal?.data?.itemId && modal?.data?.other?.metadata?.name.indexOf("Moon") === -1
      ? `https://moonpets.com/api/nftThumbnailimage/${modal?.data?.itemId}`
      : image;

  // const bnbPrice = useGetUSDPriceOfToken('wbnb', item?.price)?.data?.wbnb?.usd;
  // const order = useGetOrder(
  //   modal?.data?.signature,
  //   modal?.data?.kind,
  //   modal?.data?.chain,
  // ).data;
  // const order = useGetOrder(signature, kind, chain)?.data;

  return (
    <ModalContainer modalKey={MODAL_KEY} title={`Cancel ${isGlobal ? "Global" : ""} Offer`}>
      {/* <Toaster position='top-right' /> */}

      {/* <!-- Body --> */}
      <div className="modal-body p-6">
        {/* {!isGlobal && ( */}
        <ModalItemDetails item={item} collection={collection} isGlobal={offer?.isGlobal} />
        {/* )} */}
        <div className="relative flex border-jacarta-100 pb-4 dark:border-jacarta-600">
          <div className="mt-2 w-full">
            <div className="flex w-full">
              <div className="">Current Listing Price:</div>
              <div className="ml-auto flex w-fit space-x-1">
                <span className="ml-auto flex items-center whitespace-nowrap">
                  <div className="hidden pt-0.5"></div>
                  <ChainIcon
                    width={14}
                    name={item?.chain}
                    tooltip={getTokenName(item?.chain)}
                    // sideGap={true}
                    pt={0.5}
                  />
                  <span className="text-sm font-medium tracking-tight dark:text-jacarta-100">
                    {normalizeEther(offer?.borrowAmount)}
                  </span>
                </span>
                <div className="mt-1 text-sm dark:text-jacarta-300">
                  ~ ${normalizeEther(tokenPrice * normalizeEther(offer?.borrowAmount))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- Terms --> */}
      </div>
      {/* <!-- end body --> */}

      <div className="modal-footer">
        <div className="flex items-center justify-center space-x-4">
          {
            /*  modal?.data?.chain !== currentChainId ? (
              <button
                type="button"
                className="rounded-xl bg-accent py-3 px-8 text-center font-semibold text-white transition-all hover:bg-accent-dark"
                onClick={() => switchNetwork(modal?.data?.chain)}
              >
                Switch to{" "}
                {
                  supportedChains.find((c) => c.hexId === modal?.data?.chain)
                    ?.name
                }
              </button>
            ) : */ <button
              type="button"
              className={`${
                buttonText !== "Cancel Order" && "opacity-40"
              } rounded-xl bg-accent py-3 px-8 text-center font-semibold text-white transition-all hover:bg-accent-dark`}
              onClick={onCancel}
              disabled={buttonText !== "Cancel Order"}
            >
              {buttonText}
            </button>
          }
        </div>
      </div>
    </ModalContainer>
  );
};

export default CancelModal;
